import { ActionsHelperService } from '@/domain/actions/actions.helper.service';
import { Component, type OnInit, inject } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { AbstractWidgetClass } from '../../../../components/widgets/AbstractWidget.class';
import { DashboardingProvider } from '../../../../providers/dashboarding.provider';
import { WidgetSize } from '../../../../providers/widgets.contants';
import { Page, RoutingService } from '../../../../services/routing/routing.service';
import { ActionPlanFeatureService } from '../../action-plan-feature.service';
import { ActionPlanService } from '../../services/action-plan.service';
import { type PieChartDataPoint, type PieChartDataSource, WidgetPieChartComponent } from './widget-pie-chart/widget-pie-chart';

@Component({
    styleUrls: ['./widget-actions-state.scss'],
    selector: 'widget-actions-state',
    templateUrl: 'widget-actions-state.html',
    imports: [WidgetPieChartComponent]
})
export class WidgetActionsStateComponent extends AbstractWidgetClass<null, void> implements OnInit {
    private _dashboardingProvider = inject(DashboardingProvider);
    private _routingService = inject(RoutingService);
    private _actionsService = inject(ActionPlanService);
    private _actionsHelperService = inject(ActionsHelperService);
    private _actionsFeatureService = inject(ActionPlanFeatureService);

    size = WidgetSize.HALF;

    pieDataSource!: PieChartDataSource;

    ngOnInit() {
        const data$ = this._dashboardingProvider.getSelectedNodeId$().pipe(
            switchMap(nodeId => this._actionsService.getClassificationNodeActionStats$(nodeId)),
            map(actionStats => {
                const data: PieChartDataPoint[] = [
                    {
                        label: 'PIE_CHARTS.HOME.ACTIONS.SHORT_LEVEL_1',
                        shortLabel: 'PAGES.BOARD_BUILDING_ACTIONS.ACTIONS_TODO',
                        color: this._actionsHelperService.getActionStatusColor('todo'),
                        value: actionStats.todoActionCount
                    },
                    {
                        label: 'PIE_CHARTS.HOME.ACTIONS.SHORT_LEVEL_2',
                        shortLabel: 'PAGES.BOARD_BUILDING_ACTIONS.ACTIONS_PENDING',
                        color: this._actionsHelperService.getActionStatusColor('pending'),
                        value: actionStats.pendingActionCount
                    },
                    {
                        label: 'PIE_CHARTS.HOME.ACTIONS.SHORT_LEVEL_3',
                        shortLabel: 'PAGES.BOARD_BUILDING_ACTIONS.ACTIONS_DONE',
                        color: this._actionsHelperService.getActionStatusColor('done'),
                        value: actionStats.doneActionCount
                    }
                ];

                return data;
            })
        );

        this.pieDataSource = {
            cardIcon: 'check',
            cardTitle: 'PIE_CHARTS.HOME.ACTIONS.CHART_TITLE',
            headerButtonText: 'BUTTONS.SEE_ACTIONS',
            headerButtonClick: () => {
                this.goToActionList();
            },
            noDataTitle: 'PAGES.BUILDING_HOME.ACTIONS.NO_ACTION_TITLE',
            noDataSubtitle: 'PAGES.BUILDING_HOME.ACTIONS.NO_ACTION_SUBTITLE',
            noDataButtonText: 'PAGES.BUILDING_HOME.ACTIONS.CREATE_ACTION',
            noDataButtonClick: () => {
                this._actionsFeatureService.requestActionCreation();
            },
            loadingTitle: 'MENU.ACTIONS',
            loadingSubtitle: 'STUFF.LOADING',
            data$,
            helpButtonUrl: 'plans-action-vue-globale'
        };
    }

    private goToActionList() {
        this._routingService.goTo(Page.ACTIONS_LIST, {});
    }
}
